import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./authReducer";
import transactionParamsReducer from "./transactionParamsReducer";
import transactionTableReducer from "./transactionTableReducer";
import analyticsInfoReducer from "./analyticsInfoReducer";

const persistConfig = {
  key: "root",
  storage,
};

const appReducer = combineReducers({
  auth: authReducer,
  transactionParams: transactionParamsReducer,
  transactionTable: transactionTableReducer,
  analyticsInfo: analyticsInfoReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "SIGNOUT") {
    localStorage.removeItem("persist:root");
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
